// Gallery Slider

const gallerySlider = document.querySelectorAll('[data-slider="gallery-slider"]');

if (gallerySlider.length > 0) {
  const gallerySliderOptions = {
    slidesPerView: 'auto',
    spaceBetween: 12,
    watchOverflow: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1023: {
        slidesPerView: 'auto',
        spaceBetween: 20,
      },
    },
  };

  const initGallerySlider = () => {
    gallerySlider.forEach((el) => {
      const parentEle = el.closest('[data-slider-parent]');
      const arrowRight = parentEle.querySelector('.arrow-right');
      const arrowLeft = parentEle.querySelector('.arrow-left');
      gallerySliderOptions.navigation.nextEl = arrowRight;
      gallerySliderOptions.navigation.prevEl = arrowLeft;

      if (windowWidth() > 767) {
        new Swiper(el, gallerySliderOptions);
      } else {
        enableScrollbarSync(parentEle);
      }
    });
  };

  initGallerySlider();

  setupResponsiveSliders({
    sliderElements: gallerySlider,
    breakpoint: 767,
    initSlider: initGallerySlider,
    mobileFallback: enableScrollbarSync,
    parentSelector: '[data-slider-parent]',
  });
}
